import { takeLatest } from 'redux-saga/effects';
import {	
	getCoreValuesWinnerListSuccess, getCoreValuesWinnerListFail,
	getCurrentMonthListSuccess, getCurrentMonthListFail,
	getPreviousMonthListSuccess, getPreviousMonthListFail,
} from './corevalueswinnerState';

import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/core-values/winner');
const redirectData = { route: '/console/winner', mode: 'list', recordId: 0 };
const modelName = 'CoreValuesWinner';
const modelId = 'cvw_id';

function* getCoreValuesWinnerList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getCoreValuesWinnerListSuccess, 
		getCoreValuesWinnerListFail, 
		null, null, LOADING_MSG
	);
}

function* getCurrentMonthList() {
	yield doCrudCall(
		() => crudService.doGetRequest("current"),
		getCurrentMonthListSuccess, 
		getCurrentMonthListFail,
		null,
		null,
		LOADING_MSG
	);
}

function* getPreviousMonthList() {
	yield doCrudCall(
		() => crudService.doGetRequest("previous"),
		getPreviousMonthListSuccess, 
		getPreviousMonthListFail,
		null,
		null,
		LOADING_MSG
	);
}



function* coreValuesWinnerSaga() {
	yield takeLatest('coreValuesWinner/getCoreValuesWinnerList', getCoreValuesWinnerList);
	yield takeLatest('coreValuesWinner/getCurrentMonthList', getCurrentMonthList);
	yield takeLatest('coreValuesWinner/getPreviousMonthList', getPreviousMonthList);
}

export default coreValuesWinnerSaga;
